<form [formGroup]="form" (ngSubmit)="send()">
  <h1 mat-dialog-title>Se enviara el mail a la siguiente casilla:</h1>
  <div mat-dialog-content>
    <mat-form-field class="full-width">
      <input matInput placeholder="Email" formControlName="mail" />

      <button (click)="editMail()" matSuffix mat-icon-button type="button">
        <mat-icon>mode_edit</mat-icon>
      </button>
      <mat-error *ngIf="f.mail.errors && f.mail.errors.email">
        El mail ingresado no es válido
      </mat-error>
    </mat-form-field>
  </div>
  <div class="clearfix">
    <div class="pull-right">
      <button mat-button [disabled]="loading" type="submit">Aceptar</button>
      <button
        mat-button
        [disabled]="loading"
        type="button"
        cdkFocusInitial
        (click)="onNoClick()"
      >
        Cancelar
      </button>
    </div>
  </div>
</form>
